import _ from 'lodash';

const processStrategy = (order) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(order, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'order',
  definition: {},
  processStrategy,
};
